import {
  IndexRouteProps,
  LayoutRouteProps,
  Navigate,
  PathRouteProps,
  useLocation
} from 'react-router-dom';
import { StorageEnum } from '../../enums/storage.enum';
import { UserType } from '../../types/user.type';
import { contextDefaultAppRoutes } from '../../constants/contexts';
import { checkSession, refreshSession } from '../../helpers/session.helper';

export const PrivateRoute = (
  props: JSX.IntrinsicAttributes &
    (PathRouteProps | LayoutRouteProps | IndexRouteProps)
) => {
  const token = localStorage.getItem(StorageEnum.Token);
  const userData = localStorage.getItem(StorageEnum.UserData);
  const location = useLocation();

  if (!token || !userData) {
    return <Navigate to="/auth/login" />;
  }

  /** Un utilizator ar trebui sa poata sa acceseze doar contextul de care apartine */
  if (userData) {
    const userDataDetails: UserType = JSON.parse(userData);
    const context = contextDefaultAppRoutes.find(
      f => f.userType === userDataDetails.userType
    );

    if (!context) return <Navigate to="/auth/login" />;

    /** verific daca path-ul incepe cu appContext-ul urmat de '/' sau empty space */
    const regex = new RegExp(`^${context.appContext}(\\s|$|/)`);

    if (!regex.test(location.pathname))
      return <Navigate to={context.defaultRoute} />;
  }

  checkSession();
  refreshSession();

  /** daca trece toate validarile, il bagam pe ruta accesata */
  return <>{props.element}</>;
};
